<template>
  <div class="page-add">
    <header class="page-header">
      <h2 class="tit-h2">
        리퀘스트 추가
      </h2>
      <div class="btn-group">
        <el-button
          type="primary"
          size="large"
          aria-label="이전으로"
          class="btn-icon"
          @click="toBack"
        >
          <font-awesome-icon icon="fa-solid fa-arrow-left-long" />
        </el-button>
      </div>
    </header>
    <el-form
      :model="form"
      label-position="left"
      label-width="100px"
      class="content-box"
    >
      <section class="section">
        <h3 class="tit-h3">
          고객 정보
        </h3>
        <el-form-item label="뷰저블 계정">
          <el-input
            v-model="form.userId"
            size="large"
            style="width: 300px"
            ref="userIdInput"
            @keyup.enter="handleSearchAccount"
          >
            <template #append>
              <el-button
                aria-label="검색"
                @click="handleSearchAccount"
              >
                <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="회사명">
          <div class="form-text-viewer">
            <div
              class="text-viewer__inner"
              :style="{ width: '300px' }"
            >
              {{ form.companyName }}
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <template #label>
            히트맵<br />추천인 코드
          </template>
          <div class="form-text-viewer">
            <div
                class="text-viewer__inner"
                :style="{ width: '300px' }"
            >
              {{ form.beusRefer }}
            </div>
          </div>
          <span
            v-if="isSearch"
            :class="['input-status', {'active' : form.beusRefer }]"
          >
            {{ form.beusRefer ? '적용됨' : '미적용' }}
            <i
              :class="`icon ${form.beusRefer ? 'icon--checked' : 'icon--info'}`"
            >
            </i>
          </span>
        </el-form-item>
        <el-form-item label="저니맵 추천인 코드">
          <template #label>
            저니맵<br> 추천인 코드
          </template>
          <div class="form-text-viewer">
            <div
              class="text-viewer__inner"
              :style="{ width: '300px' }"
            >
              {{ form.baRefer }}
            </div>
          </div>
          <span
            v-if="isSearch"
            :class="['input-status', {'active' : form.beusRefer }]"
          >
            {{ form.baRefer ? '적용됨' : '미적용' }}
            <i
                :class="`icon ${form.baRefer ? 'icon--checked' : 'icon--info'}`"
            >
            </i>
          </span>
        </el-form-item>
        <el-form-item label="담당자 정보">
          <div class="form-text-viewer">
            <div class="text-viewer__inner">
              <span
                class="viewer__item"
                v-for="manager in form.manager"
                :key="manager.name"
              >
                {{ manager.name }} / {{ manager.mail }}{{ manager.phone ? ` / ${formatPhonNumber(manager.phone)}` : '' }}
              </span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="`세금계산서\n발행 정보`">
          <div class="form-text-viewer">
            <div
              class="text-viewer__inner"
            >
            <template
              v-if="form.companyName"
            >
              {{ form.taxMail ? form.taxMail.join(', ') : 'N/A' }}
            </template>
            </div>
          </div>
        </el-form-item>
      </section>
      <div
        class="detail-info-wrapper"
        :class="{disabled: !form.customerId}"
      >
        <section class="section">
          <h3 class="tit-h3">
            요청 상세 정보
          </h3>
          <el-form-item label="요청 유형">
            <el-select
              v-model="form.requestType"
              placeholder="선택하세요."
              size="large"
              style="width: 170px"
              ref="requestTypeInput"
            >
              <el-option
                v-for="item in optionsReqType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="히트맵 플랜"
            v-show="form.requestType === 'PLAN'"
          >
            <el-select
              v-model="form.beusPlanNumber"
              placeholder="선택하세요."
              size="large"
              style="width: 240px"
              ref="beusPlanInput"
            >
              <el-option
                :key="-1"
                label="Not applicable"
                :value="-1"
              />
              <el-option-group
                v-for="group in optionsPlan.beus"
                :key="group.planGroup"
                :label="group.planGroup"
              >
                <el-option
                  v-for="plan in group.plans"
                  :key="plan._id"
                  :label="plan.planName"
                  :value="plan.planNumber"
                />
              </el-option-group>
            </el-select>
            <el-text type="danger">
              <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              변경이 필요한지 확인하세요<div class=""></div>
            </el-text>
          </el-form-item>
          <el-form-item
            label="저니맵 플랜"
            v-show="form.requestType === 'PLAN'"
          >
            <el-select
              v-model="form.baPlanNumber"
              placeholder="선택하세요."
              size="large"
              style="width: 240px"
            >
              <el-option
                :key="-1"
                label="Not applicable"
                :value="-1"
              />
              <el-option-group
                v-for="group in optionsPlan.ba"
                :key="group.planGroup"
                :label="group.planGroup"
              >
                <el-option
                  v-for="plan in group.plans"
                  :key="plan._id"
                  :label="plan.planName"
                  :value="plan.planNumber"
                />
              </el-option-group>
            </el-select>
            <el-text type="danger">
              <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              변경이 필요한지 확인하세요.
            </el-text>
          </el-form-item>
          <el-form-item
            label="사용 시작일"
            v-if="form.requestType"
          >
            <el-date-picker
              v-model="form.useStartDate"
              type="date"
              placeholder="선택하세요"
              size="large"
              style="width: 170px"
              :clearable="false"
              :disabled-date="disablePastDates"
            />
          </el-form-item>
          <el-form-item
            label="계약 개월 수"
            v-show="(form.requestType === 'PLAN' || form.requestType === 'PV_CHARGE' || form.requestType === 'JAM_CHARGE') && !(form.requestType === 'PV_CHARGE' || form.requestType === 'JAM_CHARGE')"
            >
            <el-input
              v-model="form.period"
              size="large"
              style="width: 60px"
              class="input-period"
              ref="periodInput"
            />
            <el-text type="danger">
              <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              변경이 필요한지 확인하세요.
            </el-text>
          </el-form-item>
          <el-form-item
            label="사용 종료일"
            v-show="form.period"
          >
            <el-date-picker
              v-model="form.useEndDate"
              :disabled="form.requestType !== 'PV_CHARGE'"
              type="date"
              size="large"
              style="width: 170px"
              :disabled-date="setPlanDisabledDate"
            />
          </el-form-item>
          <el-form-item
            label="자동 갱신 여부"
            v-show="form.requestType === 'PLAN' || form.requestType === 'PV_CHARGE' || form.requestType === 'JAM_CHARGE'"
          >
            <el-radio-group v-model="form.recurring">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </section>
        <section
          class="section"
        >
          <h3 class="tit-h3">
            결제 정보
          </h3>
          <el-form-item label="제공 방식">
            <el-radio-group v-model="chargeType">
              <el-radio
                value="charged"
                @change="handleChargeType"
              >
                유상
              </el-radio>
              <el-radio
                value="free"
                @change="handleChargeType"
              >
                무상
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="chargeType === 'charged'">
            <el-form-item label="결제 방식">
              <el-radio-group v-model="form.paymentType">
                <el-radio
                  value="wire"
                  @change="handleChagePaymentType"
                >
                  무통장
                </el-radio>
                <el-radio
                  value="card"
                  @change="handleChagePaymentType"
                >
                  카드
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="결제 주기"
              v-show="form.period && form.requestType === 'PLAN' && Number(form.period) > 1"
            >
              <el-select
                v-model="form.paymentCycle"
                size="large"
                style="width: 170px"
                placeholder="선택하세요."
              >
                <el-option
                  v-for="item in optionsPaymentCycle"
                  :key="item"
                  :label="paymentCycleLabels[item]"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="결제 금액">
              <el-input
                v-model="form.amount"
                :formatter="(value: string) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value: string) => value.replace(/\$\s?|(,*)/g, '')"
                size="large"
                style="width: 170px"
                class="input-price"
                ref="amountInput"
              >
                <template #append>
                  원
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="결제일">
              <el-date-picker
                v-model="form.paymentDate"
                type="date"
                placeholder="선택하세요"
                size="large"
                style="width: 170px"
                :clearable="false"
                :disabled-date="disablePastDates"
              />
              <el-checkbox
                v-if="form.paymentCycle !== '0'"
                :disabled="!isEndOfMonthEnabled(form.paymentDate)"
                v-model="form.isEndOfMonth"
              >
                해당 월 마지막 날짜에 결제
              </el-checkbox>
            </el-form-item>
            <el-form-item label="서류 발행">
              <div
                class="document-row"
                v-for="(documentInput, index) in documentInputs"
                :key="index"
              >
                <div class="document-col">
                  <el-select
                    v-model="documentInput.docType"
                    placeholder="서류 유형"
                    size="large"
                    style="width: 120px"
                    >
                    <el-option
                      v-for="item in optionsDocumentType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
                <div class="document-col">
                  <el-date-picker
                    v-model="documentInput.actionDate"
                    type="date"
                    placeholder="발행일 선택"
                    size="large"
                    style="width: 130px"
                    :clearable="false"
                    :disabled-date="disablePastDates"
                  />
                </div>
                <div class="document-col">
                  <el-select
                    v-model="documentInput.email"
                    placeholder="발행 이메일"
                    size="large"
                    style="width: 200px"
                  >
                    <el-option
                      v-for="item in options.optionsIssueEmail"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :class="{disabled: (disabledEmail === 'all' && item.value !== 'manager') || disabledEmail === item.value}"
                    />
                  </el-select>
                </div>
                <div class="document-col">
                  <el-checkbox
                    v-if="form.period && form.requestType === 'PLAN' && form.paymentCycle !== '0'"
                    v-model="documentInput.periodic"
                    label="주기별 발행"
                  />
                  <el-checkbox
                    v-if="form.period && form.requestType === 'PLAN' && form.paymentCycle !== '0' && documentInput.periodic"
                    :disabled="!isEndOfMonthEnabled(documentInput.actionDate)"
                    v-model="documentInput.isEndOfMonth"
                  >
                    해당 월 마지막 날짜에 결제
                  </el-checkbox>
                </div>
                <el-button
                  v-if="!(form.paymentType === 'wire' && documentInput.docType === 'TAX_INVOICE')"
                  type="primary"
                  text
                  round
                  aria-label="삭제"
                  @click="handleRemoveDocument(index)"
                >
                <font-awesome-icon icon="fa-regular fa-trash-can" />
              </el-button>
              </div>
              <el-button
                type="primary"
                plain
                @click="handleAddDocument"
              >
                <font-awesome-icon icon="fa-solid fa-plus" />
                추가
              </el-button>
            </el-form-item>
          </template>
        </section>
        <section class="section">
          <h3 class="tit-h3">
            메모
          </h3>
          <el-input
            v-model="form.memo"
            :rows="5"
            type="textarea"
            placeholder="입력하세요"
          />
        </section>
      </div>
    </el-form>
    <div class="btn-group">
      <el-button
        type="primary"
        size="large"
        @click="handleSubmit"
      >
        저장
      </el-button>
      <el-button
        type="default"
        size="large"
        @click="toBoard"
      >
        취소
      </el-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { RequestTypeKeys, optionsReqType, PaymentTypeKeys, PaymentCycleTypeKeys, DocumentTypeKeys, optionsDocumentType } from "@/types/constants";
import { disablePastDates, formatPhonNumber } from '@/utils';
import * as options from '@/utils/options';
import { getUserInfo, getCustomerInfo, createRequest } from "@/api";
import { ElMessage, ElMessageBox, ElInput, ElSelect } from 'element-plus'
import { usePlanStore } from "@/stores/plan";
import moment from "moment";

const router = useRouter();
const toBoard = () => router.push("/");
const toBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/');
  }
}

interface Form {
  userId: string,
  baRefer?: string,
  beusRefer?: string,
  companyName: string,
  customerId: string,
  manager: string,
  taxMail: string,
  requestType: RequestTypeKeys | undefined,
  beusPlanNumber: number | undefined,
  baPlanNumber: number | undefined,
  useStartDate: Date,
  period: string | undefined,
  useEndDate: Date | null,
  recurring: boolean | null,
  paymentType: PaymentTypeKeys,
  paymentCycle: PaymentCycleTypeKeys,
  amount: number,
  paymentDate: Date,
  isEndOfMonth: boolean,
  memo: string,
}

const form = reactive<Form>({
  userId: '',
  baRefer: '',
  beusRefer: '',
  companyName: '',
  customerId: '',
  manager: '',
  taxMail: '',
  requestType: undefined,
  beusPlanNumber: undefined,
  baPlanNumber: undefined,
  useStartDate: new Date(),
  period: undefined,
  useEndDate: null,
  recurring: false,
  paymentType: 'wire',
  paymentCycle: '0',
  amount: 0,
  paymentDate: new Date(),
  isEndOfMonth: false,
  memo: '',
})

const isSearch =ref<boolean>(false)

const planStore = usePlanStore();
// console.log('Beus', planStore.beusPlanData);
// console.log('Ba', planStore.baPlanData);
const planGroupLabels: Record<string, string> = {
  PAID: '일반',
  ENT: '엔터프라이즈',
  UNUSED: '미사용플랜',
};

const optionsPlan = computed(() => {
  const groupPlans = (planData: any[]) => {
    const grouped: Record<string, typeof planData> = {};
    for (const plan of planData) {
      const group = plan.planGroup || '';
      if (group === 'VOID') continue;
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(plan);
    }
    return Object.entries(grouped)
      .sort(([a], [b]) => {
        if (a === 'UNUSED') return 1;
        if (b === 'UNUSED') return -1;
        return 0;
      })
      .map(([planGroup, plans]) => ({
        planGroup: planGroupLabels[planGroup] ?? planGroup,
        plans,
      }));
  };

  return {
    beus: groupPlans(planStore.beusPlanData),
    ba: groupPlans(planStore.baPlanData)
  };
});

const defaultEmail = ref('manager')
const disabledEmail = ref('all')

const handleSearchAccount = async () => {

  if (form.userId.length < 1 ) {
    ElMessageBox.alert('검색어를 입력해주세요.', { confirmButtonText: '확인' });
    return
  }

  const params = {
    userId: form.userId
  }

  try {
    // const response = await getUserInfo(params);
    const response = await getCustomerInfo(params);
    // console.log(response);
    if(response.success) {
      if(response.result) {
        const customer = response.result;
        Object.assign(form, {
          baRefer: customer.baRefer,
          beusRefer: customer.beusRefer,
          companyName: customer.companyName,
          customerId: customer.customerId,
          manager: customer.manager,
          taxMail: customer.taxInfo?.taxInfoDetail
        });
        setEmailType(customer.taxInfo)
        isSearch.value = true
      } else {
        Object.assign(form, {
          baRefer: '',
          beusRefer: '',
          companyName: '',
          customerId: '',
          manager: '',
          taxMail: []
        });
        defaultEmail.value = 'manager',
        disabledEmail.value = 'all'
        ElMessageBox.alert('존재하지 않는 계정입니다.', { confirmButtonText: '확인' });
        isSearch.value = false
      }

    }
  } catch (error) {
    isSearch.value = false
    console.error('Error Message:', error);
    ElMessageBox.alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요.', {
      confirmButtonText: '확인',
      dangerouslyUseHTMLString: true
    });
  }
}

const setEmailType = (typeInfo) => {
  if (!typeInfo) {
    documentInputs.value[0].email = 'manager'
    defaultEmail.value = 'manager'
    disabledEmail.value = 'all'
  } else if (typeInfo.taxInfoType === 'SYSTEM') {
    documentInputs.value[0].email = 'system'
    defaultEmail.value = 'system',
    disabledEmail.value = 'tax'
  } else {
    documentInputs.value[0].email = 'tax'
    defaultEmail.value = 'tax',
    disabledEmail.value = 'system'
  }
}

watch(() => form.requestType, (newVal) => {
  if (newVal === null) return;
  const defaultValues = {
    PLAN: { beusPlanNumber: -1, baPlanNumber: -1, useStartDate: new Date(), period: '1', recurring: false },
    PV_CHARGE: { beusPlanNumber: undefined, baPlanNumber: undefined, useStartDate: new Date(), period: '1', recurring: false },
    JAM_CHARGE: { beusPlanNumber: undefined, baPlanNumber: undefined, useStartDate: new Date(), period: '60', recurring: false },
    ADDITIONAL: { beusPlanNumber: undefined, baPlanNumber: undefined, useStartDate: new Date(), period: undefined, recurring: null },
  };

  Object.assign(form, defaultValues[newVal] || {});
});

watch(() => [form.useStartDate, form.period], () => {
  if (form.requestType === 'ADDITIONAL') {
    form.useEndDate = null
  } else {
    const startYear = form.useStartDate.getFullYear();
    const startMonth = form.useStartDate.getMonth();
    const startDate = form.useStartDate.getDate();
    const period = Number(form.period);
    if (startDate >= 29) form.useEndDate = new Date(startYear, startMonth + period + 1, 0);
    else form.useEndDate = new Date(startYear, startMonth + period, startDate - 1);
  }
}, { immediate: true });

const paymentCycleLabels: Record<string, string> = {
  "0": '일시납',
  "1": '월납',
  "2": '격월납',
  "3": '분기납',
  "4": '4개월납',
  "6": '반기납',
};

const optionsPaymentCycle = reactive<string[]>([]);

watch(() => form.period, (newVal) => {
  const period = Number(newVal);
  if (!isNaN(period) && period > 0) {
    optionsPaymentCycle.splice(0, optionsPaymentCycle.length, ...["0", "1", ...Object.keys(paymentCycleLabels)
      .filter(key => Number(key) > 1 && period % Number(key) === 0 && Number(key) !== period)]);

    if (!optionsPaymentCycle.includes(form.paymentCycle)) {
      form.paymentCycle = '0';
    }
  } else {
    optionsPaymentCycle.splice(0, optionsPaymentCycle.length);
    form.paymentCycle = '0';
  }
});

const isEndOfMonthEnabled = (date: Date): boolean => {
  const isLastDayOfMonth = (date: Date): boolean => {
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() + 1);
    return nextDay.getDate() === 1;
  }

  const month = date.getMonth() + 1;
  const isLastDay = isLastDayOfMonth(date);

  return isLastDay && (month === 2 || [4, 6, 9, 11].includes(month));
}

interface Document {
  docType: DocumentTypeKeys | undefined,
  actionDate: Date,
  email: 'tax' | 'manager' | 'system',
  periodic: boolean,
  isEndOfMonth: boolean
}

const documentInputs = ref<Document[]>([{
  docType: 'TAX_INVOICE',
  actionDate: new Date(),
  email: defaultEmail.value,
  periodic: false,
  isEndOfMonth: false
}]);

const chargeType = ref<string>('charged');

const handleChargeType = () => {
  if (chargeType.value === 'charged') {
    form.paymentType = 'wire'
    handleChagePaymentType()
  } else {
    form.paymentType = 'free'
  }
}

const handleChagePaymentType = () => {

  documentInputs.value = documentInputs.value.filter((doc: Document) => doc.docType !== undefined);

  if (form.paymentType === 'wire') {
    const hasTaxInvoice = documentInputs.value.some((doc:Document) => doc.docType === "TAX_INVOICE");

    if (!hasTaxInvoice) {
      documentInputs.value.unshift({
        docType: 'TAX_INVOICE',
        actionDate: new Date(),
        email: 'tax',
        periodic: false,
        isEndOfMonth: false
      })
    }
  } else {
    documentInputs.value = documentInputs.value.filter((doc: Document) => doc.docType !== "TAX_INVOICE");
  }
};

const handleAddDocument = () => {
  documentInputs.value.push({
    docType: undefined,
    actionDate: new Date(),
    email: defaultEmail.value,
    periodic: false,
    isEndOfMonth: false
  });
}

const handleRemoveDocument = (index: number) => documentInputs.value.splice(index, 1);

const handleSubmit = async () => {

  let formData = {
    companyName: form.companyName,
    customerId: form.customerId,
    userId: form.userId,
    baRefer: form.baRefer,
    beusRefer: form.beusRefer,
    manager: form.manager,
    requestType: form.requestType,
    baPlanNumber: form.baPlanNumber === -1 ? null : Number(form.baPlanNumber),
    beusPlanNumber: form.beusPlanNumber === -1 ? null : Number(form.beusPlanNumber),
    useStartDate: moment(form.useStartDate).format('YYYY-MM-DD'),
    useEndDate: form.useEndDate? moment(form.useEndDate).format('YYYY-MM-DD') : null,
    period: Number(form.period),
    recurring: form.recurring,
    paymentType: form.paymentType,
    isEndOfMonth: form.isEndOfMonth,
    memo: form.memo,

  }

  if (chargeType.value === 'charged') {
    const updatedDocumentInput = documentInputs.value
    .filter((doc) => doc.docType !== undefined)
    .map((doc) =>  {
      return {
        ...doc,
        actionDate: moment(doc.actionDate).format('YYYY-MM-DD'),
        email: doc.email === 'tax' ? form.taxMail : doc.email === 'manager' ? form.manager.map(em => em.mail) : 'system',
        periodic: doc.periodic,
        isEndOfMonth: doc.isEndOfMonth
      }
    });

    formData = { ...formData,
      amount: Number(form.amount),
      paymentCycle: Number(form.paymentCycle),
      paymentDate: moment(form.paymentDate).format('YYYY-MM-DD'),
      docs: updatedDocumentInput
    }
  }
  try {
    // console.log(formData)

    if(validateFormData(formData)) {
      const response = await createRequest(formData);
      console.log('리퀘스트 생성 성공:', response);
      ElMessageBox.alert('리퀘스트를 생성했습니다. 보드로 이동합니다.', {
        confirmButtonText: '확인',
        callback: () => {
          router.push({name: 'Board'});
        },
      });
    } else return;
  } catch (error) {
    console.error('Error Message:', error)
    ElMessage.error('리퀘스트 생성에 실패했습니다. 다시 시도해주세요')
  }
};

type InputRef = {
  focus: () => void;
  value?: string | number;
};

const userIdInput = ref<InputRef>();
const requestTypeInput = ref<InputRef>();
const beusPlanInput = ref<InputRef>();
const periodInput = ref<InputRef>();
const amountInput = ref<InputRef>();

const validateFormData = (formData: Form) => {
  const showAlertAndFocus = (message: string, inputRef: InputRef | undefined) => {
    ElMessageBox.alert(message, { confirmButtonText: '확인' });
    if (inputRef && inputRef.focus) inputRef.focus();
    return false;
  };

  if (!formData.userId) return showAlertAndFocus('뷰저블 계정을 입력해주세요.', userIdInput.value);
  if (!formData.companyName) return showAlertAndFocus('뷰저블 계정을 정확히 입력해주세요.', userIdInput.value);
  if (!formData.requestType) return showAlertAndFocus('요청 유형을 선택해주세요.', requestTypeInput.value);
  if (formData.requestType === 'PLAN' && formData.beusPlanNumber == null && formData.baPlanNumber == null) return showAlertAndFocus('플랜을 선택해주세요.', beusPlanInput.value);
  if (formData.requestType !== 'ADDITIONAL' && (isNaN(formData.period) || formData.period <= 0)) return showAlertAndFocus('계약 개월 수를 바르게 입력해주세요.', periodInput.value);
  if (chargeType.value === 'charged' && (isNaN(formData.amount) || formData.amount <= 0)) return showAlertAndFocus('금액을 바르게 입력해주세요.', amountInput.value);

  return true;
};
const setPlanDisabledDate = (date: Date) => {
  const start = new Date(form.useStartDate);
  const target = new Date(start.setDate(start.getDate() + 1))
  target.setHours(0, 0, 0, 0);
  return date < target;
}
</script>

<style>
.form-text-viewer {
  padding: 10px 15px;
  min-height: 40px;
  background-color: rgba(0, 0, 0, .04);
  border-radius: 8px;
  /* box-shadow: 0 0 0 1px #e4e7ed; */
  .text-viewer__inner {
    width: 580px;
    line-height: 38px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    color: #909399;
    line-height: 1.5;
  }
}
.el-select-dropdown__item.disabled {
  pointer-events: none;
  opacity: .4;
}

.page-add {
  .icon {
    display: block;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }

  .icon--info {
    background-image: url(../../assets/images/ico-info.svg);
  }

  .icon--checked {
    background-image: url(../../assets/images/ico-checked.svg);
  }

  .input-status {
    color: #888;
    margin-left: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;

    &.active {
      color: #57AB00
    }
  }
}
</style>
